



import "./NewEngineering.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../Images/Marine services 2.jpg.jpeg'
import Aboutbg from '../Images/new_m_1.png'
import Footer from "../Component/NewFooter";

const services = [
  {
    id: "valves",
    label: "Valves Asset Management",
    title: "At Jeyshawn Engineering Limited, our marine support services includes provision and management of marine vessels for transportation, offshore logistics, towing, anchor handling, and supply operations.",
    intro:
      "We support offshore installations, pipeline laying, platform maintenance, subsea works, and field development activities with experienced marine crews and well-maintained assets.",
    intro1:
      "We operate in full compliance with international maritime standards, client specifications, and regulatory requirements, with strong emphasis on safety, environmental protection, and operational excellence. Through effective planning, coordination, and real-time marine operations management, we help clients minimize risks, reduce downtime, and maintain continuous offshore operations.",
    intro2:
      "Our marine expertise supports shallow water, deepwater, and near-shore projects, delivering dependable marine solutions tailored to the unique demands of the oil and gas industry.",
  }
];

 const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction & Camp Setup",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                 href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];



export default function Marine() {
  return (
    <>
      <div className="img_carrierss">
        <img src={Avatar1} alt="" />
      </div>

      <section className="service-detail" style={{ backgroundImage: `url(${Aboutbg})` }}>
        <div className="service-detail__layout">

          {/* Left — Content (your existing JSX, unchanged) */}
          <div className="service-detail__content">
            <h2 className="service-detail__title">{services[0].title}</h2>
            <span className="service-detail__divider" />
            <p className="service-detail__intro">{services[0].intro}</p>
            <p className="service-detail__intro">{services[0].intro1}</p>
            <p className="service-detail__intro">{services[0].intro2}</p>
            {/* {services[0].sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => (
                    <li key={j} className="service-detail__list-item">{item}</li>
                  ))}
                </ul>
              </div>
            ))} */}
          </div>

          {/* Right — Nav links instead of state buttons */}
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink
                key={s.href}
                to={s.href}
                className={({ isActive }) =>
                  `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`
                }
              >
                {s.label}
              </NavLink>
            ))}
          </nav>

        </div>
      </section>
      <Footer/>
    </>
  );
}


 